import * as React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
import ButtonBase from '@mui/material/ButtonBase';
import { Add } from '../../../../Icons';

interface Props {
	icon?: React.ReactNode;
	selected?: boolean;
	onClick?: () => void;
}

const Service: React.FC<Props> = ({ children, selected, icon, onClick }) => {
	const theme = useTheme('FlightInfoCard').SegmentServices;

	return (
		<div className={cn(theme.service, { [theme.service_selected]: selected })} onClick={onClick}>
			<div className={theme.service__icon}>{icon}</div>
			{children}

			{!selected && <ButtonBase className={theme.service__add}>{Add}</ButtonBase>}
		</div>
	);
};

export default Service;
